<template>
    <div class="skt">
        <div
            v-for="(item, index) in Array(+count).fill('')"
            :key="`count${index}`"
            class="skt-count"
        >
            <span
                v-for="(citem, cindex) in Array(+column).fill('')"
                :key="`column${cindex}`"
                class="skt-column"
            >
                <div
                    v-if="avatar"
                    :class="['skt-avatar', { 'skt-animated': animate}]"
                />
                <div class="skt-content">
                    <div
                        v-if="title"
                        :class="['skt-title', { 'skt-animated': animate}]"
                    />
                    <div
                        v-for="(ritem, rindex) in Array(+row).fill('')"
                        :key="rindex"
                        :class="['skt-row', { 'skt-animated': animate}]"
                    />
                </div>
            </span>
        </div>
    </div>
</template>
<script>
export default {
  name: 'PageSkeleton',
  props: {
    /**
       * 列表展示多少项
       */
    count: {
      type: [String, Number],
      default: 1,
    },
    /**
       * 是否展示头像
       */
    avatar: {
      type: Boolean,
      default: false,
    },
    /**
       * 是否展示标题
       */
    title: {
      type: Boolean,
      default: false,
    },
    /**
       * 段落占位图行数
       */
    row: {
      type: [String, Number],
      default: 1,
    },
    /**
       * 段落占位图列数
       */
    column: {
      type: [String, Number],
      default: 1,
    },
    /**
       * 是否开启动画
       */
    animate: {
      type: Boolean,
      default: false,
    },
    /**
       * 是否显示骨架屏
       */
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="less" scoped>
.skt {
  display: flex;
  width: 100%;
  flex-direction: column;
  &-avatar {
      width: 36px;
      border-radius: 50%;
      height: 36px;
      margin-right: 16px;
      background-color: #f2f3f5;
      flex-shrink: 0;
  }
  &-content {
      padding-top: 8px;
      display: flex;
      flex-direction: column;
      width: 100%;
  }
  &-count {
      display: flex;
      width: 100%;
      margin-top: 15px;
  }

  &-title {
      height: 20px;
      width: 50%;
      background-color: #f2f3f5;
  }
  &-row:not(:first-child) {
      margin-top: 12px;
  }
  &-column {
      display: inline-flex;
      width: 100%;
      flex-shrink: 0;
      flex: 1;
  }
  &-column:not(:first-child) {
      margin-left: 32px;
  }
  &-row {
      height: 20px;
      background-color: #f2f3f5;
      border-radius: 2px;
  }
  &-title+&-row {
      margin-top: 16px;
  }
  &-animated {
      background: linear-gradient(90deg,hsla(0,0%,74.5%,.2) 25%,hsla(0,0%,50.6%,.24) 37%,hsla(0,0%,74.5%,.2) 63%);
      background-size: 400% 100%;
      animation: skeleton-loading 1.4s ease infinite;
  }
}
@keyframes skeleton-loading {
  0% {
      background-position: 100% 50%
  }
  to {
      background-position: 0 50%
  }
}
</style>
